// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"46eecd7c","674":"19282126","689":"2f96a48f","702":"02d8a412","714":"baa54719","876":"87eda439"}[chunkId] + ".chunk.js";
};